const checkDrawer = setInterval(() => {
    const drawer = document.querySelector('.wishlist-drawer-show');
    const filter = document.querySelector('.mobile-facets__disclosure');

    // console.log("drawer",drawer);
    // console.log("drawer",drawer);


    function toggleBodyClass() {
        const wishlistOpen = drawer && drawer.classList.contains('show');
        const filterOpen = filter && filter.hasAttribute('open');

        document.body.classList.toggle(
            'wishlist-open',
            wishlistOpen || filterOpen
        );
    }

    if (drawer || filter) {
        clearInterval(checkDrawer);

        toggleBodyClass();

        // drawer && new MutationObserver(toggleBodyClass).observe(drawer, {
        //     attributes: true,
        //     attributeFilter: ['class']
        // });

        filter && new MutationObserver(toggleBodyClass).observe(filter, {
            attributes: true,
            attributeFilter: ['open']
        });
    }
}, 500);

const accordions = document.querySelectorAll('.product__accordion details');

accordions[0]?.setAttribute('open', '');

accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
        if (this.open) {
            accordions.forEach((item) => {
                if (item !== this) {
                    item.removeAttribute('open');
                }
            });
        }
    });
});